import { ExtendedButtonProps } from "@components/general/Button/Button";
import { useWorkspaceContext } from "@state/workspaceContext";
import { forwardRef, useMemo } from "react";
import { NavigationDropdownToggle } from "@components/general/NavigationDropdownToggle/NavigationDropdownToggle";

const MAX_WORKSPACE_SHORT_NAME_LENGTH = 13;

export const DefaultNavigationDropdownToggle: React.FC<ExtendedButtonProps> =
    forwardRef(({ onClick }, ref) => {
        const { activeWorkspace } = useWorkspaceContext();

        const shortName = useMemo(() => {
            const workspaceName = activeWorkspace?.name ?? "";
            return workspaceName.length > MAX_WORKSPACE_SHORT_NAME_LENGTH
                ? `${workspaceName.slice(0, MAX_WORKSPACE_SHORT_NAME_LENGTH)}...`
                : workspaceName;
        }, [activeWorkspace?.name]);

        return (
            <NavigationDropdownToggle onClick={onClick} ref={ref as any}>
                {shortName}
            </NavigationDropdownToggle>
        );
    });
